/**
 * THE THREE THINGS `main.js` LENDS DOWNWARDS — as a leaf, not an import.
 *
 * `ui/cards.js` is the shared card renderer. Four surfaces reuse it: the game
 * page, the offline marketing renderer, the self-play dashboard and the Card
 * Admin Plane. Only the first is the app.
 *
 * But `cards.js` reached `main.js` through THREE edges —
 * `ui/account-menu.js` wanted `Account`, `ui/moon-exchange.js` wanted
 * `consumeAndShowCloudAchievementBanners`, and `guest-session.js` wanted
 * `MoonfallSignIn` — so importing the renderer pulled in the entire
 * application: 95 modules, Firebase and Convex booting on pages that have
 * neither, and their failures printed to a console nobody is watching.
 *
 * Every one of those three is used INSIDE A FUNCTION BODY, behind `?.`, on a
 * path that only the game page ever takes. That is the same shape as the
 * `i18n → socket-handler` edge that `i18n-events.ts` already broke: an optional
 * runtime capability written as a mandatory static import. The import says
 * "I need the app to exist"; the call site says "…if it happens to be there".
 *
 * So `main.js` REGISTERS on load and the three consumers READ. On the game page
 * nothing changes — main.js is in the bundle and runs before any of these paths
 * can fire. On the other three pages the slots stay null and the existing `?.`
 * guards no-op, which is exactly what they were already written to do.
 *
 * DELIBERATELY A FIXED SET, NOT A BAG. Three named pairs, not a generic
 * `register(name, value)` — otherwise this becomes `window.UI` with extra steps,
 * and the whole point of the conversion was to delete that. A fourth capability
 * has to be added here on purpose, and `tests/unit/client-bundle/appServices.test.js`
 * fails if the file grows a general-purpose setter.
 */

/** The sign-in card wiring that lives in main.js (guest-session's "sign-in moment"). */
let signInPresenter: any = null;

/** The account actions menu items invoke (sign out, delete account). */
let accountActions: any = null;

/** Drains cloud achievements queued while the player was away. */
let cloudAchievementBannerConsumer: any = null;

export function setSignInPresenter(value: any): void { signInPresenter = value ?? null; }
export function getSignInPresenter(): any { return signInPresenter; }

export function setAccountActions(value: any): void { accountActions = value ?? null; }
export function getAccountActions(): any { return accountActions; }

export function setCloudAchievementBannerConsumer(value: any): void {
  cloudAchievementBannerConsumer = typeof value === 'function' ? value : null;
}
export function getCloudAchievementBannerConsumer(): any { return cloudAchievementBannerConsumer; }
